import type {FC} from 'react'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import SlideshowOutlinedIcon from '@mui/icons-material/SlideshowOutlined'
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined'
import type {SvgIconProps} from '@mui/material'
import type {AttachmentKind} from '@containers/Dashboards/AgentChat/attachments'

const ICONS: Record<AttachmentKind, FC<SvgIconProps>> = {
  image: InsertDriveFileOutlinedIcon, // images render as thumbnails, never as a chip
  spreadsheet: TableChartOutlinedIcon,
  pdf: PictureAsPdfOutlinedIcon,
  word: DescriptionOutlinedIcon,
  presentation: SlideshowOutlinedIcon,
  file: InsertDriveFileOutlinedIcon,
}

/**
 * The icon on an attachment chip. A chip is all the user sees of a file they
 * cannot preview, so the icon is what tells them at a glance which one it is —
 * with five types now accepted, one generic icon for all of them would not.
 */
const AttachmentIcon: FC<{kind: AttachmentKind} & SvgIconProps> = ({kind, ...props}) => {
  const Icon = ICONS[kind] ?? InsertDriveFileOutlinedIcon
  return <Icon fontSize="small" color="action" {...props} />
}

export default AttachmentIcon
